import { c } from 'react-compiler-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import classes from './CounterLabel.module.css.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';

const CounterLabel = /*#__PURE__*/forwardRef((t0, forwardedRef) => {
  const $ = c(21);
  let children;
  let className;
  let rest;
  let scheme;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      scheme,
      className,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = scheme;
    $[5] = variant;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    scheme = $[4];
    variant = $[5];
  }
  let t1;
  if ($[6] !== children) {
    t1 = /*#__PURE__*/jsxs(VisuallyHidden, {
      children: ["\xA0(", children, ")"]
    });
    $[6] = children;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const label = t1;
  const inferredVariant = variant || scheme || "secondary";
  let t2;
  if ($[8] !== forwardedRef || $[9] !== inferredVariant || $[10] !== rest) {
    t2 = {
      ref: forwardedRef,
      "aria-hidden": "true",
      "data-variant": inferredVariant,
      ...rest
    };
    $[8] = forwardedRef;
    $[9] = inferredVariant;
    $[10] = rest;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const counterProps = t2;
  let t3;
  if ($[12] !== className) {
    t3 = clsx(className, classes.CounterLabel);
    $[12] = className;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== children || $[15] !== counterProps || $[16] !== t3) {
    t4 = /*#__PURE__*/jsx("span", {
      ...counterProps,
      className: t3,
      children: children
    });
    $[14] = children;
    $[15] = counterProps;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== label || $[19] !== t4) {
    t5 = /*#__PURE__*/jsxs(Fragment, {
      children: [t4, label]
    });
    $[18] = label;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
});
CounterLabel.displayName = 'CounterLabel';

export { CounterLabel as default };
